import React from 'react';
import { useHistory } from 'react-router-dom';
import { StatusBadge } from 'src/Components/TicketsTable/components';
import CompleteTicketButton from 'src/Components/Tickets/CompleteTicketButton';
import { BackIcon } from 'src/assets/Images';
import { COMPLETED } from 'src/Utils/constants';
import { Header, BackButton, TicketInfo, TicketDetails, Title, StatusSection, TicketInfoSection, ActionsContainer, } from './styles';
var TicketDetailsHeader = function (_a) {
    var ticketNumber = _a.ticketNumber, status = _a.status, building = _a.building, apartment = _a.apartment, date = _a.date, service = _a.service, showNotifyCheckbox = _a.showNotifyCheckbox, onCompleteTicket = _a.onCompleteTicket, _b = _a.hideCompleteButton, hideCompleteButton = _b === void 0 ? false : _b, _c = _a.entityLabel, entityLabel = _c === void 0 ? 'Ticket' : _c;
    var goBack = useHistory().goBack;
    var handleBackClick = function () {
        goBack();
    };
    var isTerminalState = status === COMPLETED;
    return (React.createElement(Header, null,
        React.createElement(TicketInfo, null,
            React.createElement(BackButton, { onClick: handleBackClick },
                React.createElement("img", { src: BackIcon, alt: "Back" })),
            React.createElement(TicketDetails, null,
                React.createElement(StatusSection, null,
                    React.createElement(Title, null,
                        entityLabel,
                        " #",
                        ticketNumber),
                    React.createElement(StatusBadge, { status: status })),
                React.createElement(TicketInfoSection, null,
                    React.createElement("span", null,
                        React.createElement("strong", null, "Edificio:"),
                        " ",
                        building),
                    React.createElement("span", null, "|"),
                    apartment && (React.createElement(React.Fragment, null,
                        React.createElement("span", null,
                            React.createElement("strong", null, "Apartamento:"),
                            " ",
                            apartment),
                        React.createElement("span", null, "|"))),
                    React.createElement("span", null,
                        React.createElement("strong", null, "Fecha:"),
                        " ",
                        date),
                    service && (React.createElement(React.Fragment, null,
                        React.createElement("span", null, "|"),
                        React.createElement("span", null,
                            React.createElement("strong", null, "Servicio:"),
                            " ",
                            service)))))),
        React.createElement(ActionsContainer, null, !hideCompleteButton && (React.createElement(CompleteTicketButton, { onClick: onCompleteTicket, disabled: isTerminalState, showNotifyCheckbox: showNotifyCheckbox })))));
};
export default TicketDetailsHeader;
